/* eslint-disable */
import {
  Space,
  Spin
} from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';


import { useAppSelector } from 'app/store';
import HeaderPage from 'common/components/HeaderPage';
import {
  getProjectByIdService
} from 'common/services/extends/project';
import roles, { getPermission } from 'configs/roles';
import InfoCard from 'extends/TimeSheet/InfoCard';
import TimeKeepingTable from './TimeKeepingTable';

const CreateTimeKeeping: React.FC<ActiveRoles> = ({
  roleIndex
}) => {
  /* Hooks */
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const rolesUser = useAppSelector((state) => state.auth.roles);

  const projectId = searchParams.get('projectId') || '';

  /* States */
  const queryKey = ['project-detail', projectId];

  const { isLoading, data: projectRes } = useQuery(
    queryKey,
    () => getProjectByIdService(projectId),
    {
      enabled: !!projectId && roleIndex,
    }
  );

  /* Render */
  return (
    <>
      <HeaderPage
        fixed
        title={t('sidebar.programTimekeeping')}
      />
      <Spin spinning={isLoading}>
        <div className="t-mainlayout_wrapper">
          <Space direction="vertical" style={{ width: '100%' }}>
            <InfoCard />
            {
              getPermission(rolesUser, roles.PAYROLL_PERIOD_INDEX) && (
                <TimeKeepingTable fromDate={projectRes?.projectData?.fromDate || ''} toDate={`${projectRes?.projectData?.toDate} 23:59:59` || ''} />
              )
            }
          </Space>
        </div>
      </Spin>
    </>
  );
};

export default CreateTimeKeeping;
